<template>
  <div class="case base">
    <inside-header title="课程安排" />
    <div class="main">
      <div class="list">
        <van-empty v-if="list.length === 0 && !loading" description="没有课程安排哦~" />
        <div v-for="(item, index) in list" :key="index" class="item">
          <div class="student-info">
            <div class="pull-left nick-name">
              {{ item.student_nick_name }}
            </div>
            <div class="pull-right time">
              {{ item.teaching_date }}
            </div>
          </div>
          <div class="course">
            {{ item.teaching_subject }}-{{ item.service_pack_title }}
          </div>
          <div class="address">
            {{ item.student_address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'CourseArrangement',
  components: {
    InsideHeader
  },
  data() {
    return {
      loading: true,
      list: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: 'index/teacher/courseArrange',
        method: 'get'
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          this.list = res.data.list
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .main {
    padding: 10px;
  }
  .list {
    .item {
      padding: 15px;
      background-color: #f9f9f9;
      border-radius: 10px;
      margin-bottom: 10px;

      .student-info {
        overflow hidden
        line-height: 28px;

        .nick-name {
        }

        .time {
          font-size: 14px;
          color: #666666;
        }
      }

      .course {
        font-family: PingFang-SC-Bold;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 28px;
      }

      .address {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 28px;
        color: #666666;
      }
    }
  }
</style>
